import { CustomHandle } from '@/adapter/blockAdapter';
import { SelectedContext } from '@/context/SelectedContext';
import { useState } from 'react';

export const SelectedProvider = ({ children }: { children: React.ReactNode }) => {
  const [selectedEdge, setSelectedEdge] = useState<CustomHandle>();

  return (
    <SelectedContext.Provider
      value={{
        selectedEdge: selectedEdge,
        setSelectedEdge: setSelectedEdge
      }}
    >
      {children}
    </SelectedContext.Provider>
  );
};
